import { render, staticRenderFns } from "./member_agreement_ai_study.vue?vue&type=template&id=b8f980b4&scoped=true"
import script from "./member_agreement_ai_study.vue?vue&type=script&lang=js"
export * from "./member_agreement_ai_study.vue?vue&type=script&lang=js"
import style0 from "./member_agreement_ai_study.vue?vue&type=style&index=0&id=b8f980b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f980b4",
  null
  
)

export default component.exports